export function hasFalsyAllFields<T extends Record<string, any>>(obj: T): boolean {
  return Object.values(obj).every((value) => isFalsy(value));
}

export function hasNoFalsySomeFields<T extends Record<string, any>>(obj: T): boolean {
  return Object.values(obj).some((value) => !isFalsy(value));
}

function isFalsy(value: any): boolean {
  if (value === undefined || value === null) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (typeof value === "number" && (value === 0 || isNaN(value))) return true;
  if (typeof value === "boolean" && value === false) return true;
  if (value instanceof Date && isNaN(value.getTime())) return true;
  return false;
}
